import React from "react";
import { Text } from "sprint-common-web";

import { requiredTokens, optionalTokens } from "../../../common/tokens";

export const commandTextFieldTooltipContent = (
    <>
        <Text styles={{ root: { fontWeight: "bold" } }}>Supported tokens:</Text>
        {Object.values(requiredTokens).map((token) => (
            <Text key={token}>{`${token} - required`}</Text>
        ))}

        <br />

        {Object.values(optionalTokens).map((token) => (
            <Text key={token}>{`${token} - optional`}</Text>
        ))}
    </>
);
